<template>
  <div>
    <label
      :class="'subtitle-2 gray70--text d-inline-flex ' + labelPosition"
      :for="idElement"
      v-if="labelText"
    >
      {{ labelText }}
    </label>
    <vue-tel-input-vuetify
      v-on="$listeners"
      v-bind="defaultConfigs"
      :id="idElement"
      class="base-form-phone"
      label=""
      :input-options="{ showDialCode: true, tabIndex: 0 }"
    />
  </div>
</template>
<script lang="ts">
const defaultProp = {
  outlined: true,
  class: "mt-2 caption",
  dense: true,
  "background-color": "white",
};
import { Component, Vue, Prop } from "vue-property-decorator";
@Component
export default class BaseFormPhone extends Vue {
  @Prop(String) idElement: string;
  @Prop(String) labelText: string;
  @Prop({ default: "justify-start" }) labelPosition: string;
  get defaultConfigs() {
    return {
      ...this.$attrs,
      ...this.$props,
      ...defaultProp,
    };
  }
}
</script>
<style lang="sass">
.vue-tel-input-vuetify
  fieldset
    border: none !important
    border: 1px solid var(--v-gray15-base) !important
    border-radius: 16px !important
.base-form-phone__
  &eye
    float: right
  &button
    min-width: 20px !important
    height: 14px !important
    padding: 0 !important
  &no-error
    .v-text-field__details
      display: none !important
</style>
